import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MailX, Loader2 } from "lucide-react";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.get(`/email/unsubscribe/${token}`).then((r) => setState({ ok: true, message: r.data.message }))
      .catch((e) => setState({ ok: false, message: e.response?.data?.detail || "This link is no longer valid." }));
  }, [token]);
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="unsubscribe-page">
      <MailX className="w-10 h-10 mx-auto text-primary mb-4" />
      <h1 className="font-display text-2xl font-bold mb-2">{state.loading ? "One moment…" : state.ok ? "You're unsubscribed" : "Link not valid"}</h1>
      {state.loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : <p className="text-muted-foreground text-sm" data-testid="unsubscribe-message">{state.message}</p>}
      <p className="text-xs text-muted-foreground mt-4">Changed your mind? Switch reminders back on under Billing &amp; account.</p>
      <Button asChild variant="outline" className="mt-6"><Link to="/">Back to the site</Link></Button>
    </div>
  );
}
